import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import { GridCellV7 as MemoizedGridCellV7 } from "../components/cell/GridCell.es.js";
import { GridColumnHeaders as MemoizedGridColumnHeaders } from "../components/GridColumnHeaders.es.js";
import { GridColumnMenu } from "../components/menu/columnMenu/GridColumnMenu.es.js";
import { GridNoResultsOverlay } from "../components/GridNoResultsOverlay.es.js";
import materialSlots from "../material/index.es.js";
import { GridSkeletonCell } from "../components/cell/GridSkeletonCell.es.js";
import { GridColumnHeaderFilterIconButton } from "../components/columnHeaders/GridColumnHeaderFilterIconButton.es.js";
import { GridFooter } from "../components/GridFooter.es.js";
import { GridRowCount } from "../components/GridRowCount.es.js";
import { GridPreferencesPanel } from "../components/panel/GridPreferencesPanel.es.js";
import { GridLoadingOverlay } from "../components/GridLoadingOverlay.es.js";
import { GridNoRowsOverlay } from "../components/GridNoRowsOverlay.es.js";
import { GridPagination } from "../components/GridPagination.es.js";
import { GridFilterPanel } from "../components/panel/filterPanel/GridFilterPanel.es.js";
import { GridColumnsPanel } from "../components/panel/GridColumnsPanel.es.js";
import { GridPanel } from "../components/panel/GridPanel.es.js";
import { GridRow as MemoizedGridRow } from "../components/GridRow.es.js";
const DATA_GRID_DEFAULT_SLOTS_COMPONENTS = _extends({}, materialSlots, {
  Cell: MemoizedGridCellV7,
  SkeletonCell: GridSkeletonCell,
  ColumnHeaderFilterIconButton: GridColumnHeaderFilterIconButton,
  ColumnMenu: GridColumnMenu,
  ColumnHeaders: MemoizedGridColumnHeaders,
  Footer: GridFooter,
  FooterRowCount: GridRowCount,
  Toolbar: null,
  PreferencesPanel: GridPreferencesPanel,
  LoadingOverlay: GridLoadingOverlay,
  NoResultsOverlay: GridNoResultsOverlay,
  NoRowsOverlay: GridNoRowsOverlay,
  Pagination: GridPagination,
  FilterPanel: GridFilterPanel,
  ColumnsPanel: GridColumnsPanel,
  Panel: GridPanel,
  Row: MemoizedGridRow
});
export {
  DATA_GRID_DEFAULT_SLOTS_COMPONENTS
};
//# sourceMappingURL=defaultGridSlotsComponents.es.js.map
